import Constants from "expo-constants";

export const EUREKA_CLIENT_ID =
  Constants.expoConfig?.extra?.eurekaClientId ?? "website";

export const EUREKA_AUTHORIZATION_ENDPOINT =
  Constants.expoConfig?.extra?.eurekaAuthorizationEndpoint ??
  "https://eureka.towersystems.com.au/oauth2/authorize";

export const EUREKA_TOKEN_ENDPOINT =
  Constants.expoConfig?.extra?.eurekaTokenEndpoint ??
  "https://eureka.towersystems.com.au/api/oauth2/token";

export const EUREKA_SCOPES = ["website"];

export const EUREKA_REDIRECT_PATH =
  Constants.expoConfig?.extra?.eurekaRedirectPath ?? "/auth/callback/eureka";

export const PKCE_VERIFIER_KEY_PREFIX = "eureka_pkce_verifier_"; // + state
